import { Typography } from '@mui/material'
import { AccountReactivateOutlineIcon } from '@weblite/icons'
import { SecondaryButton } from '$common/buttons'
import { t } from '$i18n'
import { showHowToSyncIOSContactsModal } from '$comp/modals/how-to-sync-ios-contacts/how-to-sync-ios-contacts.api'
import { useLastCallback } from '$hooks/use-last-callback'
import { isContactsSupported } from '$func/environmentInfo'
import { selectContacts } from '$logic/contacts/service'

export function SyncIOSContactsFab() {
  const handleClick = useLastCallback(() => {
    if (isContactsSupported()) selectContacts()
    else showHowToSyncIOSContactsModal()
  })

  return (
    <SecondaryButton
      sx={{
        borderRadius: '24px',
        padding: '12px',
      }}
      text={
        <Typography variant="subtitle3" color="neutral900">
          {t('syncIOSAccounts.fabButtonLabel')}
        </Typography>
      }
      onClick={handleClick}
      size="medium"
      endIcon={
        <AccountReactivateOutlineIcon
          sx={{ width: '24px', height: '24px', mr: '4px' }}
        />
      }
    />
  )
}
